/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pg_Signup_DiscordInputs */



/**
* | output |
* | --- |
* | "### Discord If you have a Discord account, tap the Discord button. You'll be redirected to Discord to authorise, then sent back to Archon with your account r..." |
*
* @param {Pg_Signup_DiscordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const pg_signup_discord = /** @type {((inputs?: Pg_Signup_DiscordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pg_Signup_DiscordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("### Discord\n\nSi vous avez un compte Discord, appuyez sur le bouton Discord. Vous serez redirigé vers Discord pour autoriser, puis renvoyé sur Archon avec votre compte prêt.")
	if (locale === "es") return /** @type {LocalizedString} */ ("### Discord\n\nSi tiene una cuenta de Discord, pulse el botón de Discord. Será redirigido a Discord para autorizar, y luego regresará a Archon con su cuenta lista.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("### Discord\n\nSe você tem uma conta no Discord, toque no botão do Discord. Você será redirecionado para o Discord para autorizar, e então retornará ao Archon com sua conta pronta.")
	if (locale === "it") return /** @type {LocalizedString} */ ("### Discord\n\nSe hai un account Discord, premi il pulsante Discord. Verrai reindirizzato a Discord per autorizzare, poi riportato su Archon con l'account pronto.")
	return /** @type {LocalizedString} */ ("### Discord\n\nIf you have a Discord account, tap the Discord button. You'll be redirected to Discord to authorise, then sent back to Archon with your account ready.")
});